import React from "react";
import {
  AppPage,
  MimaButton,
  MimaTable,
  PageLoader,
} from "../../../components";
import useFashThemes from "./useLogic/useFashThemes";
import AddThemeModal from "./AddThemeModal";
import { AnimatePresence } from "framer-motion";

const FashThemes = () => {
  const {
    openAddThemeModal,
    closeModal,
    addThemeModal,
    tableData,
    isLoading,
    isFetching,
    tableColumns,
  } = useFashThemes();
  return (
    <AppPage pageTitle="Fash Themes">
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          <MimaButton
            title="Add New Theme"
            onClick={openAddThemeModal}
            mb={2}
          />

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Business Audit"
            searchVariant="wide"
            totalItems={20}
            // onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={50}
            // currentPage={currentPage}
            // setCurrentPage={setCurrentPage}
            // setSearchQuery={setSearchQuery}
          />
        </>
      )}

      {addThemeModal && (
        <div className="modal">
          <AnimatePresence>
            {addThemeModal && <AddThemeModal closeModal={closeModal} />}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default FashThemes;
